import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="network-header">
      <div className="container">
        <nav className="nav-wrapper">
          <Link to="/" className="network-logo" onClick={closeMobileMenu}>
            Offgrid IT
          </Link>

          <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className={`network-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
            <Link to="/" className="network-nav-link" onClick={closeMobileMenu}>
              Home
            </Link>
            <Link to="/services" className="network-nav-link" onClick={closeMobileMenu}>
              Services
            </Link>
            <Link to="/contact" className="network-nav-link" onClick={closeMobileMenu}>
              Contact
            </Link>
            <a href="tel:+27724603624" className="network-nav-link nav-phone">
              <Phone size={16} />
              <span>+27 72 460 3624</span>
            </a>
          </div>
        </nav>
      </div>
    </header>);

};

export default Header;